import { createAction, props } from '@ngrx/store';
import { Dividend, DividendCreate } from '../../models/dividend.model';
import { PaginationState } from '../../models/stock.model';

// Load Dividends
export const loadDividends = createAction(
  '[Dividends] Load Dividends',
  props<{ stockId?: string; filters?: { pageNumber?: number; pageSize?: number } }>()
);
export const loadDividendsSuccess = createAction(
  '[Dividends] Load Dividends Success',
  props<{ dividends: Dividend[]; pagination: PaginationState }>()
);
export const loadDividendsFailure = createAction(
  '[Dividends] Load Dividends Failure',
  props<{ error: any }>()
);

// Load Single Dividend
export const loadDividend = createAction('[Dividends] Load Dividend', props<{ id: string }>());
export const loadDividendSuccess = createAction(
  '[Dividends] Load Dividend Success',
  props<{ dividend: Dividend }>()
);
export const loadDividendFailure = createAction(
  '[Dividends] Load Dividend Failure',
  props<{ error: any }>()
);

// Create Dividend
export const createDividend = createAction(
  '[Dividends] Create Dividend',
  props<{ dividend: DividendCreate }>()
);
export const createDividendSuccess = createAction(
  '[Dividends] Create Dividend Success',
  props<{ dividend: Dividend }>()
);
export const createDividendFailure = createAction(
  '[Dividends] Create Dividend Failure',
  props<{ error: any }>()
);

// Update Dividend
export const updateDividend = createAction(
  '[Dividends] Update Dividend',
  props<{ id: string; dividend: DividendCreate }>()
);
export const updateDividendSuccess = createAction(
  '[Dividends] Update Dividend Success',
  props<{ dividend: Dividend }>()
);
export const updateDividendFailure = createAction(
  '[Dividends] Update Dividend Failure',
  props<{ error: any }>()
);

// Delete Dividend
export const deleteDividend = createAction('[Dividends] Delete Dividend', props<{ id: string }>());
export const deleteDividendSuccess = createAction(
  '[Dividends] Delete Dividend Success',
  props<{ id: string }>()
);
export const deleteDividendFailure = createAction(
  '[Dividends] Delete Dividend Failure',
  props<{ error: any }>()
);
